import { path } from 'ramda'
import { useSelector, shallowEqual } from 'react-redux'

import { Settings, dataKey } from 'app/reducers/settings/dishes'

export { dataKey }

export const useDishesSettings = () => {
  const settings: Settings = useSelector(path(['settings', dataKey]), shallowEqual)!
  return settings
}
